// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__oHAx1","productName":"Table_productName__L04-N"};